import React, { useState, useRef } from 'react'
import csvIcon from '../assets/images/csv.png';

const ImportPopup = (props) => {
    const [file, setFile] = useState(null);
    const fileInputRef = useRef(null);
    const [checkedFields, setCheckedFields] = useState([]);
    const [checkedFieldsState, setCheckedFieldsState] = useState([]);

    const handleFileChange = (event) => {
        setFile(event.target.files[0]);

    };

    const xlFields = [
        { "label": "Name", "value": "Name" },
        { "label": "Address1", "value": "Address1" },
        { "label": "Address2", "value": "Address2" },
        { "label": "Address3", "value": "Address3" },
        { "label": "Address4", "value": "Address4" },
        { "label": "Address5", "value": "Address5" },
        { "label": "EmailAddress", "value": "EmailAddress" },
        { "label": "TelephoneNumber", "value": "TelephoneNumber" },
        { "label": "WebsiteAccess", "value": "WebsiteAccess" },
        { "label": "PricingBand", "value": "PricingBand" },
        { "label": "AcceptCWOOnly", "value": "AcceptCWOOnly" },
        { "label": "CreditLimit", "value": "CreditLimit" },
        { "label": "RouteDays", "value": "RouteDays" },
        { "label": "AccountObjective1", "value": "AccountObjective1" },
        { "label": "AccountObjective2", "value": "AccountObjective2" },
        { "label": "Sectors", "value": "Sectors" },
        { "label": "SubDepot", "value": "SubDepot" },
        { "label": "Intro Email", "value": "IntroEmail" },
    ];

    const handleUpload = () => {
        if (file) {
            props.closePopup(null, true, file, props.impValue, checkedFields);
        } else {
            alert('Please select a file before uploading.');
        }
    };

    const handleOnChangeFields = (position, e) => {


        const updatedCheckedState = checkedFieldsState.map((item, index) => {
            return index === position ? !item : item;
        });

        var updatedList = [...checkedFields];

        if (e.target.checked) {
            updatedList = [...checkedFields, e.target.value];
        } else {
            updatedList.splice(checkedFields.indexOf(e.target.value), 1);
            if (e.target.value === "EmailAddress") {
                updatedList = updatedList.filter(f => f !== "IntroEmail");
                const introIndex = xlFields.findIndex(f => f.value === "IntroEmail");
                if (introIndex > -1) updatedCheckedState[introIndex] = false;
            }
        }
        setCheckedFields(updatedList);
        setCheckedFieldsState(updatedCheckedState);

    };

    const triggerFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click(); // Programmatically trigger the file input click event
        }
    };


    return (

        <div className="product-import-pop">
            <div className="product-import-pop-overlay"></div>
            <div className="product-import-wrap">
                <span className="close-import-pop" onClick={() => props.closePopup(null, false, null, null)}></span>

                <div className="product-import-body">
                    <div className="product-import-header">
                        <h3>Import {props.impValue} by CSV</h3>
                    </div>
                    <div className="product-import-content">
                        {file && (<div className='file-added'><p>Added File</p></div>)}
                        {!file && (<div className="custom-file-add">
                            <div className="custom-file" onClick={triggerFileInput}>
                                <span>Add File</span>
                                <input type="file" className="custom-file-input" onChange={handleFileChange} ref={fileInputRef} accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style={{ display: 'none' }} />
                            </div>
                        </div>)}
                        {file && (
                            <div className="custom-file-choose">
                                <p><span className="file-icon"><img src={csvIcon} /></span>{file.name}</p>
                                <button onClick={triggerFileInput}>Replace File</button>
                                <input
                                    type="file"
                                    className="custom-file-input"
                                    onChange={handleFileChange}
                                    ref={fileInputRef}
                                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                    style={{ display: 'none' }} // Hide the file input element
                                />
                            </div>
                        )}
                        <div className="input-field">
                            <label>No field selection is needed to insert New Customer Data. To update existing records, select one or more matching fields below.</label>
                            <br />
                            <div>
                                <a onClick={() => {
                                    const allChecked = xlFields.map(() => true);
                                    setCheckedFieldsState(allChecked);
                                    setCheckedFields(xlFields.map(field => field.value));
                                }}>Select All</a> |&nbsp;
                                <a onClick={() => {
                                    const noneChecked = xlFields.map(() => false);
                                    setCheckedFieldsState(noneChecked);
                                    setCheckedFields([]);
                                }}>Deselect All</a>
                            </div><br />
                            {xlFields.map(
                                (field, index) =>
                                    <div key={field.value} className="check-box no-strike" style={{ display: "inline-block", width: "200px" }}>
                                        <input
                                            type="checkbox"
                                            name="FieldTobeExcluded"
                                            id={`FieldTobeExcluded${index}`}
                                            value={field.value}
                                            checked={checkedFieldsState[index]}
                                            disabled={field.value === "IntroEmail" && !checkedFields.includes("EmailAddress")}
                                            onChange={(e) => handleOnChangeFields(index, e)}

                                        />
                                        <label htmlFor={`FieldTobeExcluded${index}`} className = {field.value === "IntroEmail" ? "highlight" : ""}>
                                            {field.label}{" "}
                                        </label>
                                    </div>

                            )}
                        </div>
                    </div>
                    <div className="product-import-bottom">
                        <button className="button cancel-btn" onClick={() => props.closePopup(null, false, null, null)}>Cancel</button>
                        <button className={`button upload-btn ${!file ? 'disabled' : 'active'}`} onClick={handleUpload} disabled={!file}>Upload and Continue</button>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ImportPopup;